import { ResponseDayExerciseLogs } from './../../../core/model/api-response/plans-response-model';
import { AddActivityLogParams } from './../../../core/model/object/exercise-model';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DietSearchMealModel } from 'src/app/core/model/object/diet-model';
import { Weightlog } from 'src/app/core/model/api-response/weight-log-response-model';
import { ExerciseItem } from 'src/app/core/model/api-response/plans-response-model';

@Injectable()
export class BottomsheetShared {
  constructor() {}

  private _selectedPackage: DietSearchMealModel;
  private _selectedDate: Date;
  private _selectedWeightlog: Weightlog;
  private _selectedFoodFactsNames: string[];
  private _selectedFoodFactsAmounts: number[];
  private _selectedFoodFactsUnits: string[];
  private _selectedFoodName: string;
  private _selectedFoodSecondUnit: string;
  private _selectedDietId: string;
  private _selectedDay: string;
  private _selectedMeal: string;
  private _bottomsheetType: string;
  private _startDay: number;
  private _shareLink: string;
  private _met: number;
  private _exerciseTitle: string;
  private _exerciseItem: ExerciseItem;
  private _exerciseDayLog: ResponseDayExerciseLogs;
  private _isSearchHistoryExercise: boolean = false;
  private _CDate: number = new Date(new Date().setHours(0, 0, 0, 1)).getTime();

  public get CDate() {
    return this._CDate;
  }

  public set CDate(date: number) {
    this._CDate = date;
  }

  public get SearchHistoryExercise() {
    return this._isSearchHistoryExercise;
  }
  public set SearchHistoryExercise(value: boolean) {
    this._isSearchHistoryExercise = value;
  }
  public get ExerciseLogDay(): ResponseDayExerciseLogs {
    return this._exerciseDayLog;
  }
  public set ExerciseLogDay(data: ResponseDayExerciseLogs) {
    this._exerciseDayLog = data;
  }
  public get exerciseItem(): ExerciseItem {
    return this._exerciseItem;
  }
  public set exerciseItem(data: ExerciseItem) {
    this._exerciseItem = data;
  }
  public get met(): number {
    return this._met;
  }
  public set met(value: number) {
    this._met = value;
  }
  public get exerciseTitle(): string {
    return this._exerciseTitle;
  }
  public set exerciseTitle(value: string) {
    this._exerciseTitle = value;
  }

  public get startDay(): number {
    return this._startDay;
  }
  public set startDay(value: number) {
    this._startDay = value;
  }

  public get bottomsheetType(): string {
    return this._bottomsheetType;
  }
  public set bottomsheetType(value: string) {
    this._bottomsheetType = value;
  }

  public get selectedFoodName(): string {
    return this._selectedFoodName;
  }
  public set selectedFoodName(value: string) {
    this._selectedFoodName = value;
  }

  public get selectedFoodSecondUnit(): string {
    return this._selectedFoodSecondUnit;
  }
  public set selectedFoodSecondUnit(value: string) {
    this._selectedFoodSecondUnit = value;
  }

  public get selectedFoodFactsAmounts(): number[] {
    return this._selectedFoodFactsAmounts;
  }
  public set selectedFoodFactsAmounts(value: number[]) {
    this._selectedFoodFactsAmounts = value;
  }

  public get selectedFoodFactsUnits(): string[] {
    return this._selectedFoodFactsUnits;
  }
  public set selectedFoodFactsUnits(value: string[]) {
    this._selectedFoodFactsUnits = value;
  }

  public get selectedFoodFactsNames(): string[] {
    return this._selectedFoodFactsNames;
  }
  public set selectedFoodFactsNames(value: string[]) {
    this._selectedFoodFactsNames = value;
  }

  public get selectedPackage(): DietSearchMealModel {
    return this._selectedPackage;
  }
  public set selectedPackage(value: DietSearchMealModel) {
    this._selectedPackage = value;
  }

  public get selectedDate(): Date {
    return this._selectedDate;
  }
  public set selectedDate(value: Date) {
    this._selectedDate = value;
  }

  public get selectedWeightlog(): Weightlog {
    return this._selectedWeightlog;
  }
  public set selectedWeightlog(value: Weightlog) {
    this._selectedWeightlog = value;
  }

  public get selectedDietId(): string {
    return this._selectedDietId;
  }
  public set selectedDietId(value: string) {
    this._selectedDietId = value;
  }

  public get selectedDay(): string {
    return this._selectedDay;
  }
  public set selectedDay(value: string) {
    this._selectedDay = value;
  }

  public get selectedMeal(): string {
    return this._selectedMeal;
  }
  public set selectedMeal(value: string) {
    this._selectedMeal = value;
  }

  public get shareLink(): string {
    return this._shareLink;
  }
  public set shareLink(value: string) {
    this._shareLink = value;
  }

  private openBottomsheetObs = new BehaviorSubject<boolean>(false);
  openBottomsheetObs$ = this.openBottomsheetObs.asObservable();

  private closeBottomsheetObs = new BehaviorSubject<boolean>(false);
  closeBottomsheetObs$ = this.closeBottomsheetObs.asObservable();

  private closeAndUpdateBottomsheetObs = new BehaviorSubject<boolean>(false);
  closeAndUpdateBottomsheetObs$ =
    this.closeAndUpdateBottomsheetObs.asObservable();

  private closeIosBottomsheetObs = new BehaviorSubject<boolean>(false);
  closeIosBottomsheetObs$ = this.closeIosBottomsheetObs.asObservable();

  private openFirstIosBottomsheetObs = new BehaviorSubject<boolean>(false);
  openFirstIosBottomsheetObs$ = this.openFirstIosBottomsheetObs.asObservable();

  private openSecondIosBottomsheetObs = new BehaviorSubject<boolean>(false);
  openSecondIosBottomsheetObs$ =
    this.openSecondIosBottomsheetObs.asObservable();

  private openReportBottomsheetObs = new BehaviorSubject<boolean>(false);
  openReportBottomsheetObs$ = this.openReportBottomsheetObs.asObservable();

  private closeReportBottomsheetObs = new BehaviorSubject<boolean>(false);
  closeReportBottomsheetObs$ = this.closeReportBottomsheetObs.asObservable();

  private openFoodFactBottomsheetObs = new BehaviorSubject<boolean>(false);
  openFoodFactBottomsheetObs$ = this.openFoodFactBottomsheetObs.asObservable();

  private pendingFoodsConfirmObs = new BehaviorSubject<boolean>(false);
  pendingFoodsConfirmObs$ = this.pendingFoodsConfirmObs.asObservable();

  openBottomsheet() {
    this.openBottomsheetObs.next(true);
    this.openBottomsheetObs.next(false);
  }

  closeBottomsheet() {
    this.closeBottomsheetObs.next(true);
    this.closeBottomsheetObs.next(false);
  }

  closeAndUpdateBottomsheet() {
    this.closeAndUpdateBottomsheetObs.next(true);
    this.closeAndUpdateBottomsheetObs.next(false);
  }

  openReportBottomsheet() {
    this.openReportBottomsheetObs.next(true);
    this.openReportBottomsheetObs.next(false);
  }

  closeReportBottomsheet() {
    this.closeReportBottomsheetObs.next(true);
    this.closeReportBottomsheetObs.next(false);
  }

  closeIosBottomsheet() {
    this.closeIosBottomsheetObs.next(true);
    this.closeIosBottomsheetObs.next(false);
  }

  openFirstIosBottomsheet() {
    this.openFirstIosBottomsheetObs.next(true);
    this.openFirstIosBottomsheetObs.next(false);
  }

  openSecondIosBottomsheet() {
    this.openSecondIosBottomsheetObs.next(true);
    this.openSecondIosBottomsheetObs.next(false);
  }

  openFoodFactBottomsheet() {
    this.openFoodFactBottomsheetObs.next(true);
    this.openFoodFactBottomsheetObs.next(false);
  }

  pendingFoodsConfirm() {
    this.pendingFoodsConfirmObs.next(true);
    this.pendingFoodsConfirmObs.next(false);
  }
}
